<section id="intro-consulting" class="section-bg-dark">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 pl-5">
        <h2 class="text-white">MARKETING DIGITAL</h2>
      </div>
    </div>
  </div>
</section>

<section id="marketing_services">
  <div class="container">

    <div class="row">
      <div class="col-lg-4 offset-lg-1 col-md-5 col-xs-12">
        <p class="font-medium">
          El equipo de marketing especializado en entorno digital posee conocimientos
          avanzados en Inbound Marketing, posicionando al consumidor final en el centro de
          todas las acciones.
        </p>
      </div>
      <div class="col-lg-6 col-md-6 offset-md-1 d-none d-sm-none d-md-block">
        <img class="img-resp" src="assets/img/mk-draw.webp" alt="">
      </div>
    </div>
  </div>

  <div class="container">
    <div class="container">
      <div class="row p-2">
        <div class="col-xs-12 w-100 text-center p-4">
          <h2>SERVICIOS DE MARKETING DIGITAL</h2>
        </div>
      </div>
    </div>


    <div class="row justify-content-between">

      @for (section of sections; track section) {
      <div class="card col-sm-12 col-md-4 text-center p-2">
        <div class="card-body">
          <div class="border_box">
            <h5>{{ section.title }}</h5>
            <p>{{ section.description }}</p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>